import { useEffect } from 'react';

const GoogleAdsFootOverlayPC = () => {
  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(function () {
      window.googletag.defineSlot(
        '/17939840/videoac_foot_overlay_PC',
        [[980, 90], [728, 90]],
        'div-gpt-ad-1743403275042-0'
      ).addService(window.googletag.pubads());

      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      window.googletag.display('div-gpt-ad-1743403275042-0');
    });
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '300px',
          minHeight: '90px',
      }}
      className='google-ads bg-light'
    >
      <div
        id="div-gpt-ad-1743403275042-0"
        style={{
          minWidth: '300px',
          minHeight: '90px',
        }}
      ></div>
    </div>
  );
};

export default GoogleAdsFootOverlayPC;